import React, { useState } from 'react';
import { Box, Container, Typography, Button, Paper } from '@mui/material';
import AuthDialog from './AuthDialog';

const WelcomeScreen = () => {
  const [authDialogOpen, setAuthDialogOpen] = useState(false);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          py: 4,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            width: '100%',
            textAlign: 'center',
          }}
        >
          <Typography variant="h3" component="h1" gutterBottom color="primary">
            Notepad
          </Typography>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            Your Simple Personal Organizer
          </Typography>
          <Typography variant="body1" sx={{ mt: 2, mb: 4 }}>
            Manage your to-dos, track birthdays, and monitor expenses all in one place.
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={() => setAuthDialogOpen(true)}
            sx={{ px: 4, py: 1.5 }}
          >
            Get Started
          </Button>
        </Paper>
      </Box>
      <AuthDialog
        open={authDialogOpen}
        onClose={() => setAuthDialogOpen(false)}
      />
    </Container>
  );
};

export default WelcomeScreen;
